import {
    OutboundLinkContext,
    OutboundLinkDestinationCategory,
    OutboundLinkShape,
    TrackEvent,
} from '@enums';
import {
    Enum_Componentlinksproductlinks_Linksto,
    ModuleDisplayType,
} from '@graphql/generated/graphql';
import { useAnalytics } from '@lib/analytics/analyticsContext';
import { AdditionalProductActionType, ShopifyAddToCartAction } from '@types';
import { MessageType, postMessage } from '@utils/events/postMessage';
import { cloneElement, MouseEventHandler, ReactElement } from 'react';

type PropsType = {
    children: ReactElement;
    className?: string;
    action: string;
    actionPayload: object;
    destination: string;
    destination_name: string;
    destination_category:
        | OutboundLinkDestinationCategory
        | Enum_Componentlinksproductlinks_Linksto;

    context: OutboundLinkContext;
    shape: OutboundLinkShape | ModuleDisplayType;
    onClick?: MouseEventHandler<HTMLDivElement>;
    preventDefault?: boolean;
    stopPropagation?: boolean;
};

export const PostMessageCTA = ({
    children,
    className,
    action,
    actionPayload,
    onClick,
    preventDefault,
    stopPropagation,
    ...outboundLinkTrackingProps
}: PropsType) => {
    const { track } = useAnalytics();

    const handleClick: MouseEventHandler<HTMLDivElement> = (e) => {
        if (stopPropagation) e.stopPropagation();
        if (preventDefault) e.preventDefault();

        postMessage(
            window.parent,
            MessageType.ADD_TO_CART,
            actionPayload ?? {}
        );

        track(TrackEvent.OutboundLink, {
            category: 'click',
            ...outboundLinkTrackingProps,
            action: action as AdditionalProductActionType,
            actionPayload: actionPayload as ShopifyAddToCartAction,
        });

        if (onClick) {
            onClick(e);
        }
    };

    const extendedChildren = cloneElement(children, {
        onClick: handleClick,
        className,
    });

    return <>{extendedChildren}</>;
};
